import { AppModel } from '../../../modules/Apps';

import { AppsTableBody } from './AppsTableBody';
import { AppsTableEmptyState } from './AppsTableEmptyState';
import { AppsTableErrorState } from './AppsTableErrorState';
import { AppsTableLoadingState } from './AppsTableLoadingState';

interface AppsTableContentProps {
  apps: AppModel[];
  isLoading: Boolean;
  isError: Boolean;
}

export function AppsTableContent({ apps, isError, isLoading }: AppsTableContentProps) {
  if (isLoading) {
    return <AppsTableLoadingState />;
  }

  if (isError) {
    return <AppsTableErrorState />;
  }

  if (!apps.length) {
    return <AppsTableEmptyState />;
  }

  return <AppsTableBody apps={apps} />;
}
